import { PacketsListPage } from 'app/components/paperwork/PacketsListPage'
import { usePacketsList } from 'app/components/paperwork/usePacketsList'

export default function SettingsPackets() {
  const props = usePacketsList()
  return <PacketsListPage {...props} />
}
